import { render, staticRenderFns } from "./ImportHeaders.vue?vue&type=template&id=6a523372&scoped=true&"
import script from "./ImportHeaders.vue?vue&type=script&lang=js&"
export * from "./ImportHeaders.vue?vue&type=script&lang=js&"
import style0 from "./ImportHeaders.vue?vue&type=style&index=0&id=6a523372&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a523372",
  null
  
)

export default component.exports